import React from 'react';
import './RestaurantSelectionModal.scss';
import { Restaurant } from '../../../interfaces/Catalogue';
import { useConfig } from '../../../context/ConfigContext';

interface RestaurantSelectionModalProps {
  visible: boolean;
  onClose: () => void;
  restaurants: Restaurant[];
  currentRestaurant?: Restaurant | null;
  onSelect: (restaurant: Restaurant) => void;
}

const RestaurantSelectionModal: React.FC<RestaurantSelectionModalProps> = ({
  visible,
  onClose,
  restaurants,
  currentRestaurant,
  onSelect,
}) => {
  const { config } = useConfig();
  const primaryColor = config?.primaryColor || '#6366F1';

  if (!visible) return null;

  return (
    <div className="restaurant-modal-overlay" onClick={onClose}>
      <div className="restaurant-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="restaurant-modal-header">
          <div className="restaurant-modal-title">Choisissez un restaurant</div>
          <button className="restaurant-modal-close-btn" onClick={onClose}>
            <span className="restaurant-modal-close-icon">✕</span>
          </button>
        </div>

        <div className="restaurant-modal-list">
          {restaurants.sort((a, b) => a.isOpen === b.isOpen ? 0 : a.isOpen ? -1 : 1).map((item, index) => (
            <div key={item.id.toString()}>
              <div
                className={`restaurant-modal-list-item ${
                  currentRestaurant?.id === item.id ? 'restaurant-modal-list-item--selected' : ''
                }`}
                onClick={() => onSelect(item)}
                style={{
                  backgroundColor: currentRestaurant?.id === item.id
                    ? `${primaryColor}08`
                    : 'transparent'
                }}
              >
                <div className="restaurant-modal-item-wrapper">
                  <div className="restaurant-modal-item-details">
                    <div
                      className={`restaurant-modal-item-name ${
                        currentRestaurant?.id === item.id ? 'restaurant-modal-item-name--selected' : ''
                      }`}
                      style={{
                        color: currentRestaurant?.id === item.id
                          ? primaryColor
                          : '#1f2937'
                      }}
                    >
                      {item.nom}
                    </div>

                    <div className="restaurant-modal-item-meta">
                      <div
                        className={`restaurant-modal-status-badge ${
                          item.isOpen ? 'restaurant-modal-status-badge--open' : 'restaurant-modal-status-badge--closed'
                        }`}
                      >
                        <div
                          className={`restaurant-modal-status-dot ${
                            item.isOpen ? 'restaurant-modal-status-dot--open' : 'restaurant-modal-status-dot--closed'
                          }`}
                        />
                        <span
                          className={`restaurant-modal-status-label ${
                            item.isOpen ? 'restaurant-modal-status-label--open' : 'restaurant-modal-status-label--closed'
                          }`}
                        >
                          {item.isOpen ? 'Ouvert' : 'Fermé'}
                        </span>
                      </div>

                      {item.note > 0 && (
                        <span className="restaurant-modal-meta-text">
                          ⭐ {item.note.toFixed(1)}
                        </span>
                      )}

                      {item.tempsPrep > 0 && (
                        <span className="restaurant-modal-meta-text">
                          ⏱ {item.tempsPrep}min
                        </span>
                      )}
                    </div>
                  </div>

                  {currentRestaurant?.id === item.id && (
                    <div
                      className="restaurant-modal-checkmark"
                      style={{
                        backgroundColor: primaryColor
                      }}
                    >
                      <span className="restaurant-modal-checkmark-icon">✓</span>
                    </div>
                  )}
                </div>
              </div>
              {index < restaurants.length - 1 && <div className="restaurant-modal-divider" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RestaurantSelectionModal;